import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/Forgot.vue'),
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(/* webpackChunkName: "home" */ './views/Home.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "auth" */ './views/Login.vue'),
    },
    {
      path: '/change-password',
      name: 'change-password',
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(/* webpackChunkName: "home" */ './views/ChangePassword.vue'),
    },
    {
      path: '/category',
      meta: {
        breadcrumbName: 'Categories',
        requiresAuth: true,
      },
      component: () =>
        import(/* webpackChunkName: "category" */ './views/category/index.vue'),
      children: [
        {
          path: '',
          name: 'category.list',
          component: () =>
            import(/* webpackChunkName: "category" */ './views/category/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
      ],
    },
    {
      path: '/client',
      component: () =>
        import(/* webpackChunkName: "client" */ './views/client/index.vue'),
      meta: {
        breadcrumbName: 'Clients',
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'client.list',
          component: () =>
            import(/* webpackChunkName: "client" */ './views/client/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: ':client_id/edit',
          name: 'client.edit',
          component: () =>
            import(/* webpackChunkName: "client" */ './views/client/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: ':client_id/product/unassigned',
          name: 'client.product-unassigned',
          component: () =>
            import(/* webpackChunkName: "client" */ './views/client/MapProduct/index.vue'),
          meta: {
            breadcrumbName: 'Products (Unassigned)',
          },
          children: [
            {
              path: ':product_id/map',
              name: 'client.product-unassigned.map',
              component: () =>
                import(/* webpackChunkName: "project" */ './views/project/List/index.vue'),
              meta: {
                breadcrumbName: 'Map',
              },
            },
          ],
        },
        {
          path: ':client_id/product/assigned',
          name: 'client.product-assigned',
          component: () =>
            import(/* webpackChunkName: "client" */ './views/client/MapProduct/index.vue'),
          meta: {
            breadcrumbName: 'Products (Assigned)',
          },
          children: [
            {
              path: ':product_id/map',
              name: 'client.product-assigned.map',
              component: () =>
                import(/* webpackChunkName: "project" */ './views/project/List/index.vue'),
              meta: {
                breadcrumbName: 'Map',
              },
            },
          ],
        },
        {
          path: ':client_id/project',
          component: () =>
            import(/* webpackChunkName: "project" */ './views/project/index.vue'),
          meta: {
            breadcrumbName: 'Projects',
          },
          children: [
            {
              path: '',
              name: 'client.project.list',
              component: () =>
                import(/* webpackChunkName: "project" */ './views/project/List/index.vue'),
            },
            {
              path: 'new',
              name: 'client.project.new',
              component: () =>
                import(/* webpackChunkName: "project" */ './views/project/List/index.vue'),
            },
            {
              path: ':project_id/edit',
              name: 'client.project.edit',
              component: () =>
                import(/* webpackChunkName: "project" */ './views/project/List/index.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/job',
      meta: {
        breadcrumbName: 'Jobs',
        requiresAuth: true,
      },
      component: () =>
        import(/* webpackChunkName: "job" */ './views/job/index.vue'),
      children: [
        {
          path: '',
          name: 'job.list',
          component: () =>
            import(/* webpackChunkName: "job" */ './views/job/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: 'new',
          name: 'job.new',
          component: () =>
            import(/* webpackChunkName: "job" */ './views/job/Edit/index.vue'),
          meta: {
            breadcrumbName: 'New',
          },
        },
        {
          path: ':job_id/view',
          name: 'job.view',
          component: () =>
            import(/* webpackChunkName: "job" */ './views/job/List/index.vue'),
        },
      ],
    },
    {
      path: '/product',
      component: () =>
        import(/* webpackChunkName: "product" */ './views/product/index.vue'),
      meta: {
        breadcrumbName: 'Products',
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'product.list',
          component: () =>
            import(/* webpackChunkName: "product" */ './views/product/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: ':product_id/edit',
          name: 'product.edit',
          component: () =>
            import(/* webpackChunkName: "product" */ './views/product/List/index.vue'),
          meta: {
            breadcrumbName: 'Edit',
          },
        },
      ],
    },
    {
      path: '/retailer',
      component: () =>
        import(/* webpackChunkName: "retailer" */ './views/retailer/index.vue'),
      meta: {
        breadcrumbName: 'Retailers',
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'retailer.list',
          component: () =>
            import(/* webpackChunkName: "retailer" */ './views/retailer/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: ':retailer_id/edit',
          name: 'retailer.edit',
          component: () =>
            import(/* webpackChunkName: "retailer" */ './views/retailer/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: ':retailer_id/outlet',
          name: 'retailer.outlet.list',
          component: () =>
            import(/* webpackChunkName: "retailer" */ './views/outlet/List/index.vue'),
          meta: {
            breadcrumbName: 'Outlets',
          },
        },
        {
          path: ':retailer_id/outlet/:outlet_id',
          name: 'retailer.outlet.edit',
          component: () =>
            import(/* webpackChunkName: "retailer" */ './views/outlet/List/index.vue'),
          meta: {
            breadcrumbName: 'Outlets',
          },
        },
      ],
    },
    {
      path: '/review',
      component: () =>
        import(/* webpackChunkName: "review" */ './views/review/index.vue'),
      meta: {
        breadcrumbName: 'Review',
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'review.entry',
          component: () =>
            import(/* webpackChunkName: "review" */ './views/review/Task/index.vue'),
          meta: {
            breadcrumbName: 'Entries',
          },
        },
        {
          path: ':date/:category',
          name: 'review.entry.list',
          component: () =>
            import(/* webpackChunkName: "review" */ './views/review/View/index.vue'),
          props: true,
          meta: {
            breadcrumbName: 'Entries',
          },
        },
      ],
    },
    {
      path: '/task',
      component: () =>
        import(/* webpackChunkName: "task" */ './views/task/index.vue'),
      meta: {
        breadcrumbName: 'Tasks',
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'task.list',
          component: () =>
            import(/* webpackChunkName: "task" */ './views/task/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: 'new',
          name: 'task.new',
          component: () =>
            import(/* webpackChunkName: "task" */ './views/task/New/index.vue'),
          meta: {
            breadcrumbName: 'New',
          },
        },
        {
          path: 'summary',
          name: 'task.summary',
          component: () =>
            import(/* webpackChunkName: "task" */ './views/task/Summary/index.vue'),
          meta: {
            breadcrumbName: 'Summary',
          },
        },
        {
          path: 'summary/:job_id/view',
          name: 'task.summary.job.view',
          component: () =>
            import(/* webpackChunkName: "job" */ './views/task/Summary/index.vue'),
        },
        {
          path: 'calendar',
          name: 'task.calendar',
          component: () =>
            import(/* webpackChunkName: "task" */ './views/task/Calendar/index.vue'),
          meta: {
            breadcrumbName: 'Calendar',
          },
        },
        {
          path: ':task_id/approve',
          name: 'task.approve',
          component: () =>
            import(/* webpackChunkName: "task" */ './views/task/Approve/index.vue'),
          meta: {
            breadcrumbName: 'Approve',
          },
        },
        {
          path: ':task_id/split',
          name: 'task.split',
          component: () =>
            import(/* webpackChunkName: "task" */ './views/task/Split/index.vue'),
          meta: {
            breadcrumbName: 'Split',
          },
        },
        {
          path: ':task_id/view',
          name: 'task.view',
          component: () =>
            import(/* webpackChunkName: "task" */ './views/task/View/index.vue'),
          meta: {
            breadcrumbName: 'View',
          },
        },
      ],
    },
    {
      path: '/user',
      component: () =>
        import(/* webpackChunkName: "user" */ './views/user/index.vue'),
      meta: {
        breadcrumbName: 'Users',
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'user.list',
          component: () =>
            import(/* webpackChunkName: "user" */ './views/user/List/index.vue'),
          meta: {
            breadcrumbName: 'List',
          },
        },
        {
          path: ':user_id/edit',
          name: 'user.edit',
          component: () =>
            import(/* webpackChunkName: "user" */ './views/user/List/index.vue'),
          meta: {
            breadcrumbName: 'Edit',
          },
        },
      ],
    },
  ],
});

export default router;
